import { useMemo } from 'react';
import { useAxios } from './useAxios';

export const errorMessage = (err) =>
  err?.response?.data?.message || 'Une erreur est survenue. Réessayez dans un instant.';

export default function useExpressAnnonce() {
  const axios = useAxios();

  return useMemo(
    () => ({
      analyze: async (registrationFile, photoUrls) => {
        const body = new FormData();
        if (registrationFile) body.append('registration', registrationFile);
        body.append('photoUrls', JSON.stringify(photoUrls));
        // Obligatoire : votre instance force application/json, et axios convertirait le FormData en JSON
        const { data } = await axios.post('/ai/annonce/analyze', body, {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 45000,
        });
        return data;
      },
      preview: (payload) => axios.post('/ai/annonce/preview', payload).then((r) => r.data),
      publish: (payload) => axios.post('/ai/annonce/publish', payload).then((r) => r.data),
    }),
    [axios]
  );
}
